import { Header } from "../../../components/header/header.jsx";
import { ProgressBlock } from "./mainPageComponents.jsx";
import { ConnectionLines } from "./mainPageComponents.jsx";
import { RoadMapItem } from "./mainPageComponents.jsx"
import { useOpenPage } from "../../../hooks/useOpenPage.js";
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from "react-redux";
import CheckListAPI from "../../../api/CheckListAPI.js";
import MainPageAPI from "../../../api/MainPageAPI.js";
import classNames from "classnames";


import styles from "./mainPage.module.css"

const phrases = [
    "Каждый кофе - шанс взбодрить мир!",
    "Посмотри раздел продажи, давай поднажмём 💪🚀",
    "Ты сегодня обаяшка - и гости это видят 🥰",
]

export const MainPage = () => {
    const openPage = useOpenPage();

    const motivationSystem = true;

    const roadMapRef = useRef(null);

    const hours = new Date().getHours();
    const greeting = ["Доброй ночи", "Доброе утро", "Добрый день", "Добрый вечер"][Math.floor(hours / 6)];
    const userName = useSelector(state => state?.user?.name) || "Имя пользователя";

    const cafeId = useSelector(state => state?.user?.userData?.cafeId);
    const [monthlyRevenue, setMonthlyRevenue] = useState({ current: 0, goal: 1 });
    useEffect(() => {
        if (!cafeId) return;
        MainPageAPI
            .fetchShiftInfo(cafeId)
            .then(setMonthlyRevenue)
            .catch(console.error);
    }, [cafeId]);

    const [loading, setLoading] = useState(0);
    const [checklistCategories, setChecklistCategories] = useState([]);
    useEffect(() => {
        if (!cafeId) return;

        CheckListAPI
            .fetchUserChecklistCategories()
            .then((res) => {
                setChecklistCategories(res);
            })
            .catch(console.error)
            .finally(() => setLoading(prev => prev + 1));
    }, [cafeId]);

    const [items, setItems] = useState([]);
    const checkListId = useSelector(state => state.user.userData.checklistId);
    useEffect(() => {
        if (checkListId === null) return;
        CheckListAPI
            .fetchDailyTasks(checkListId)
            .then(data => setItems(data))
            .catch(console.error)
            .finally(() => setLoading(prev => prev + 1));
    }, [checkListId]);

    const filteredCheckListCategories = useMemo(() => checklistCategories.filter(data => items.filter(el => el.categoryName === data.text).length > 0), [checklistCategories, items]);
    let levelsLeft = 0;
    for (const item of items) {
        if (item.countDone < item.countTotal) {
            levelsLeft++;
        }
    }

    const circle_progress = monthlyRevenue.goal > 0.00001 ? monthlyRevenue.current / monthlyRevenue.goal : 0;

    const curPhrase = useRef(Math.floor(Math.random() * phrases.length));

    return (
        <>
            <Header title={`${greeting}, ${userName}!`} />
            <div className={styles.phrase}>
                {phrases[curPhrase.current]}
            </div>
            <ProgressBlock k={circle_progress} motivationSystem={motivationSystem} levelsLeft={levelsLeft} />
            <div className={styles.middle_text}>
                <div className={styles.middle_text_header}>
                    Карта действий на сегодня
                </div>
                <div className={classNames(styles.middle_text_caption, { [styles.enabled]: motivationSystem })}>
                    {
                        (motivationSystem)
                            ? "Пройди задания по категориям, чтобы повысить свой уровень."
                            : "Будет доступна после заполнения системы мотивации в профиле."

                    }
                </div>
            </div>
            {motivationSystem && (
                <div style={{ position: 'relative', width: '100%' }}>
                    <div className={styles.road_map} ref={roadMapRef}>
                        {filteredCheckListCategories.map((data, index) => (
                            <RoadMapItem
                                key={data.id}
                                imgSrc={data.image}
                                title={data.text}
                                done={items.filter(el => el.categoryName === data.text && el.countDone >= el.countTotal).length}
                                total={items.filter(el => el.categoryName === data.text).length}
                                ind={index + 1}
                                onClick={openPage(`/checklist?initialTab=${data.id}`)}
                            />
                        ))}
                    </div>
                    {
                        loading === 2 &&
                        <ConnectionLines containerRef={roadMapRef} />
                    }
                </div>
            )}
            {/* {motivationSystem && <Button onClick={openPage("/")} text="Поднажми!" />} */}
        </>
    )
}
